<ul class="vl-functional-header__sub__actions">
  <li class="vl-functional-header__sub__action">
      <a [routerLink]="route" class="vl-link vl-link--bold">
          <i class="vl-link__icon vl-link__icon--before vl-vi vl-vi-arrow-left-fat" aria-hidden="true"></i> Terug
      </a>
  </li>
</ul>